import { BOOKS } from "@/lib/catalog";

const W = 1600;
const H = 1000;
const GOLD = "#C9A227";

function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src.startsWith("http") ? `${src}?giftcard=1` : src;
  });
}

function wrap(ctx, text, maxWidth) {
  const lines = [];
  let line = "";
  text.split(/\s+/).forEach((word) => {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = word;
    } else line = test;
  });
  if (line) lines.push(line);
  return lines;
}

function drawCovers(ctx, covers) {
  covers.forEach((img, i) => {
    if (!img) return;
    const w = 250;
    const h = w * (img.height / img.width);
    ctx.save();
    ctx.translate(250 + i * 95, 520);
    ctx.rotate(((i - 1.5) * 7 * Math.PI) / 180);
    ctx.shadowColor = "rgba(0,0,0,0.75)";
    ctx.shadowBlur = 40;
    ctx.shadowOffsetY = 20;
    ctx.drawImage(img, -w / 2, -h / 2, w, h);
    ctx.shadowColor = "transparent";
    ctx.strokeStyle = "rgba(255,255,255,0.15)";
    ctx.lineWidth = 2;
    ctx.strokeRect(-w / 2, -h / 2, w, h);
    ctx.restore();
  });
}

function drawFrame(ctx) {
  ctx.fillStyle = "#0B0C10";
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(1150, 420, 50, 1150, 420, 800);
  glow.addColorStop(0, "rgba(201,162,39,0.20)");
  glow.addColorStop(1, "rgba(201,162,39,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 3;
  ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.strokeStyle = "rgba(201,162,39,0.4)";
  ctx.lineWidth = 1;
  ctx.strokeRect(56, 56, W - 112, H - 112);
}

function drawText(ctx, gift, origin) {
  const x = 760;
  const maxW = 740;
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = GOLD;
  ctx.font = "500 24px 'IBM Plex Mono'";
  ctx.fillText("A  GIFT  FOR  YOU", x, 170);
  ctx.fillStyle = "#F5F2EA";
  ctx.font = "600 92px 'Cormorant Garamond'";
  ctx.fillText("40 days of", x, 275);
  ctx.fillStyle = GOLD;
  ctx.font = "italic 600 92px 'Cormorant Garamond'";
  ctx.fillText("stories.", x, 365);
  ctx.fillStyle = "#A9A59B";
  ctx.font = "400 26px Manrope";
  ctx.fillText("The Leckie E-Reader — all four Michael Leckie", x, 425);
  ctx.fillText("novels to read and listen to.", x, 462);

  let y = 535;
  if (gift.message) {
    ctx.fillStyle = "#F5F2EA";
    ctx.font = "italic 500 36px 'Cormorant Garamond'";
    wrap(ctx, `“${gift.message}”`, maxW).slice(0, 4).forEach((ln) => {
      ctx.fillText(ln, x, y);
      y += 46;
    });
  }
  if (gift.from_name) {
    ctx.fillStyle = GOLD;
    ctx.font = "500 26px Manrope";
    ctx.fillText(`— ${gift.from_name}`, x, y + 6);
  }

  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 2;
  ctx.fillStyle = "rgba(201,162,39,0.08)";
  ctx.fillRect(x, 740, maxW, 110);
  ctx.strokeRect(x, 740, maxW, 110);
  ctx.fillStyle = "#A9A59B";
  ctx.font = "500 18px 'IBM Plex Mono'";
  ctx.fillText("GIFT CODE", x + 30, 775);
  ctx.fillStyle = GOLD;
  ctx.font = "500 44px 'IBM Plex Mono'";
  ctx.fillText(gift.code, x + 30, 828);
  ctx.fillStyle = "#A9A59B";
  let size = 20;
  const where = `Redeem at ${origin.replace(/^https?:\/\//, "")}/reader`;
  do {
    ctx.font = `400 ${size}px Manrope`;
    size -= 1;
  } while (ctx.measureText(where).width > maxW && size > 12);
  ctx.fillText(where, x, 886);
  ctx.font = "400 20px Manrope";
  ctx.fillText("Sign in or sign up, then choose “Have a gift code?”", x, 916);
}

export async function renderGiftCard(gift) {
  await Promise.all(
    ["500 24px 'IBM Plex Mono'", "600 92px 'Cormorant Garamond'", "italic 600 92px 'Cormorant Garamond'", "400 26px Manrope"].map((f) =>
      document.fonts.load(f).catch(() => {})
    )
  );
  const covers = await Promise.all(BOOKS.slice(0, 4).map((b) => loadImage(b.cover)));
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  drawFrame(ctx);
  drawCovers(ctx, covers);
  ctx.fillStyle = GOLD;
  ctx.font = "500 20px 'IBM Plex Mono'";
  ctx.fillText("THE LECKIE NOVELS", 110, 130);
  drawText(ctx, gift, window.location.origin);
  return canvas.toDataURL("image/png");
}
